import React, { useEffect } from "react";
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Typography,
    TextField,
    Button,
    Select,
    MenuItem,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Div from "@jumbo/shared/Div";
import { useState } from "react";
import { dateFun } from "app/utils/constants/functions";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import Swal from "sweetalert2";
import { getDetailsByOrderNo } from "app/services/apis/Inventory/getDetailsByOrderNo";
import { fetchRawOrdersScrapInventory } from "app/redux/actions/inventoryAction";
import { useDispatch } from "react-redux";

export default function OrderRowScappedManualIssue({ open, setOpen, rawScrapData }) {
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [orderDetails, setOrderDetails] = useState([]);
    const [rawMaterial, setRawMaterials] = useState({
        orders_raw_scrap_id: rawScrapData?.orders_raw_scrap_details_id,
        raw_manually_order_date: "",
        raw_manually_order_no: "",
        raw_manually_order_item_no: "",
        raw_manually_order_item_name: "",
        raw_manually_order_sub_item_name: "",
        raw_manually_factory_name: "",
        raw_manually_available_quantity: rawScrapData?.orders_raw_scrap_fabric_available,
        raw_manually_issue_quantity: "",
        taka_id: rawScrapData?.taka_id,
        raw_manually_taka_no: rawScrapData?.taka_no,
        raw_manually_taka_rack_details: rawScrapData?.raw_rack_details,
        raw_manually_remark: ''
    });

    const onClose = function () {
        setOpen(false);
    }

    const handleSubmit = async () => {
        try {
            setLoader(true);
            const config = {
                withCredentials: true,
                headers: {
                    withCredentials: true,
                },
            };
            const res = await axios.patch(`${process.env.REACT_APP_URL}/api/raw-inventory/order-raw-scrapped-manual-issue`, rawMaterial, config);
            if (res?.status === 200) {
                Swal.fire({ icon: "success", title: "Issued" });
                dispatch(fetchRawOrdersScrapInventory("", "", 1));
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: `${error?.response?.data?.message}` });
        } finally {
            setLoader(false);
            onClose();
        }
    };

    useEffect(() => {
        (async () => {
            const data = await getDetailsByOrderNo(rawMaterial?.raw_manually_order_no);
            // console.log(data);
            setOrderDetails(data?.data?.result);
        })()
    }, [rawMaterial?.raw_manually_order_no]);

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth={200}>
                <DialogTitle sx={{ fontWeight: "700" }}>
                    Raw Scrap Manually Issue
                </DialogTitle>
                <DialogContent>
                    <Div sx={{mb:3}}>
                        <Typography sx={{fontSize:"18px"}}>Order No :- {rawScrapData?.order_no}</Typography>
                        <Typography sx={{fontSize:"18px"}}>KC Fabric Code :- {rawScrapData?.order_item_kc_fabric_code}</Typography>
                    </Div>
                    <TableContainer component={Paper} sx={{ width: "100%" }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "160px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Order Date
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            verticalAlign: "middle",
                                            width: "160px",
                                            color: "white",
                                        }}
                                    >
                                        Order No.
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            verticalAlign: "middle",
                                            color: "white",
                                            width: "100px",
                                        }}
                                    >
                                        Item No.
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "180px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Item Name
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "180px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Sub Item Name
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "180px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Factory
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "20px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Available Qty
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "100px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Issue Qty
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            width: "200px",
                                            verticalAlign: "middle",
                                            color: "white",
                                        }}
                                    >
                                        Remark
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            // pl: 2,
                                            width: "160px",
                                        }}
                                    >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Div sx={{ width: "160px" }}>
                                                <DatePicker
                                                    defaultValue={rawMaterial?.raw_manually_order_date}
                                                    onChange={(date) => {
                                                        setRawMaterials({
                                                            ...rawMaterial,
                                                            raw_manually_order_date: dateFun(date),
                                                        });
                                                    }}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiInputBase-input": {
                                                            padding: 1,
                                                        },
                                                    }}
                                                />
                                            </Div>
                                        </LocalizationProvider>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <TextField
                                            size="small"
                                            name="raw_manually_order_no"
                                            sx={{ width: "160px" }}
                                            value={rawMaterial?.raw_manually_order_no}
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_order_no: e.target.value,
                                                });
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <Select
                                            size="small"
                                            value={rawMaterial.raw_manually_order_item_no}
                                            sx={{ width: "100px" }}
                                            name="raw_manually_order_item_no"
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_order_item_no: e.target.value,
                                                });
                                            }}
                                        >
                                            {orderDetails?.map((item) => {
                                                return <MenuItem value={item.order_item_no}>{item.order_item_no}</MenuItem>;
                                            })}
                                        </Select>
                                    </TableCell>

                                    <TableCell sx={{ textAlign: "left" }}>
                                        <Select
                                            size="small"
                                            value={rawMaterial.raw_manually_order_item_name}
                                            sx={{ width: "180px" }}
                                            name="raw_manually_order_item_name"
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_order_item_name: e.target.value,
                                                });
                                            }}
                                        >
                                            {orderDetails
                                                ?.filter((item) => {
                                                    return item.order_item_no === rawMaterial.raw_manually_order_item_no;
                                                })
                                                .map((item) => {
                                                    return <MenuItem value={item.order_item_name}>{item.order_item_name}</MenuItem>;
                                                })}
                                        </Select>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <Select
                                            size="small"
                                            value={rawMaterial.raw_manually_order_sub_item_name}
                                            sx={{ width: "180px" }}
                                            name="Sub_item_name"
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_order_sub_item_name: e.target.value,
                                                });
                                            }}
                                        >
                                            {orderDetails
                                                ?.filter((item) => {
                                                    return item.order_item_name === rawMaterial.raw_manually_order_item_name;
                                                })
                                                .map((item) => {
                                                    return <MenuItem value={item.order_sub_item_name}>{item.order_sub_item_name}</MenuItem>;
                                                })}
                                        </Select>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <Select
                                            size="small"
                                            value={rawMaterial.raw_manually_factory_name}
                                            sx={{ width: "180px" }}
                                            name="raw_manually_factory_name"
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_factory_name: e.target.value,
                                                });
                                            }}
                                        >
                                            {orderDetails?.map((item) => {
                                                return <MenuItem value={item.order_item_factory_name}>{item.order_item_factory_name}</MenuItem>;
                                            })}
                                        </Select>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <Typography>{rawMaterial.raw_manually_available_quantity}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <TextField
                                            type="number"
                                            size="small"
                                            name="issued_qty"
                                            sx={{ width: "100px" }}
                                            value={rawMaterial.raw_manually_issue_quantity}
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_issue_quantity: Number(e.target.value),
                                                });
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>
                                        <TextField
                                            multiline
                                            type="number"
                                            size="small"
                                            name="raw_manually_remark"
                                            sx={{ width: "200px" }}
                                            value={rawMaterial?.raw_manually_remark}
                                            onChange={(e) => {
                                                setRawMaterials({
                                                    ...rawMaterial,
                                                    raw_manually_remark: e.target.value,
                                                });
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Div
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 3,
                            mb: 2
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => {
                                navigate("/dashboard/inventory");
                            }}
                        >
                            Cancel
                        </Button>
                        <LoadingButton loading={loader} variant="contained" onClick={handleSubmit} sx={{ width: "100px" }}>
                            Issue
                        </LoadingButton>
                    </Div>
                </DialogActions>
            </Dialog>
        </>
    );
}